import {FormModel} from "../../../../models/forms/form.model";
import {IChangePasswordFormFields} from "./change-password-form-fields.interface";
import {IServiceFactory} from "../../../service-factory.interface";
import {IChangePasswordFormViewModel} from "./change-password-form-view-model.interface";
import {FormFields, IFormField} from "../../../../models/forms/form-field.interface";
import {ILoginResponse} from "../../../airline-webapi/responses/login.response";



export class ChangePasswordFormModel extends FormModel<IChangePasswordFormFields> implements IChangePasswordFormViewModel {

    constructor(services: IServiceFactory, private readonly refreshToken: string) {
        super(services);
    }

    protected _createFields(): FormFields<IChangePasswordFormFields> {
        const language = this.services.language;
        return {
            oldPassword: this._createPasswordField({
                isRequired: true,
                fieldName: () => language.translate('Old password'),
            }),
            newPassword: this._createPasswordField({
                isRequired: true,
                fieldName: () => language.translate('New password')
            }),
            confirmPassword: this._createPasswordField({
                isRequired: true,
                fieldName: () => language.translate('Confirm new password'),
                validate: this._validateConfirmPassword
            })
        };
    }

    async executeChangePassword(): Promise<ILoginResponse | null> {
        if(this.activateErrorsValidation().length > 0) {
            return null;
        }

        const fields = this.fields;
        return await this.services.loadingIndicator.execute({
            action: async () => {
                const session = await this.services.user.getSession();
                const response = await this.services.airlineWebapi.changePassword({
                    dotRezToken: session.token,
                    refreshToken: this.refreshToken,
                    currentPassword: fields.oldPassword.value!,
                    newPassword: fields.newPassword.value!
                });

                if(response.hasError) {
                    this.services.alert.showError(this.services.language.translateApiError(response.errorCode));
                    return null;
                }
                return response.data;
            }
        })
    }

    private _validateConfirmPassword = (field: IFormField<string>): string | null => {
        if(!field.value){
            return null;
        }

        if(this.fields.newPassword.value !== field.value){
            return this.services.language.translate("The new password and password confirmation fields should match");
        }
        return null;
    }

}